// there are more options available from the API but the list
//  is limited to these for now.
// see here: https://hello.planet.com/code/product/mono/blob/master/services/yats/README-api.md
export const PROCESS_MAP = {
  RGB: 'rgb',
  CIR: 'cir',
  NDVI: 'ndvi',
  NDWI: 'ndwi',
  VARI: 'vari',
  MSAVI2: 'msavi2',
  MTVI2: 'mtvi2',
} as const;

export const PROCESS_BAND_COMBINATIONS = 'Band Combinations';
export const PROCESS_SPECTRAL_INDICES = 'Spectral Indices';

export const PROCESS_CATEGORIES = {
  [PROCESS_BAND_COMBINATIONS]: [PROCESS_MAP.RGB, PROCESS_MAP.CIR],
  [PROCESS_SPECTRAL_INDICES]: [
    PROCESS_MAP.NDVI,
    PROCESS_MAP.NDWI,
    PROCESS_MAP.VARI,
    PROCESS_MAP.MSAVI2,
    PROCESS_MAP.MTVI2,
  ],
} as const;

export const PROCESSES = {
  [PROCESS_MAP.RGB]: {
    key: PROCESS_MAP.RGB,
    name: PROCESS_MAP.RGB.toUpperCase(),
    label: 'True color visualization (default)',
  },
  [PROCESS_MAP.CIR]: {
    key: PROCESS_MAP.CIR,
    name: PROCESS_MAP.CIR.toUpperCase(),
    label: 'Color Infrared',
  },
  [PROCESS_MAP.NDVI]: {
    key: PROCESS_MAP.NDVI,
    name: PROCESS_MAP.NDVI.toUpperCase(),
    label: 'Normalized Difference Vegetation Index',
  },
  [PROCESS_MAP.NDWI]: {
    key: PROCESS_MAP.NDWI,
    name: PROCESS_MAP.NDWI.toUpperCase(),
    label: 'Normalized Difference Water Index',
    tooltip:
      'The index uses Near-Infrared (NIR) instead of Short-wave Infrared (SWIR)',
  },
  [PROCESS_MAP.VARI]: {
    key: PROCESS_MAP.VARI,
    name: PROCESS_MAP.VARI.toUpperCase(),
    label: 'Visible Atmospherically Resistant Index',
  },
  [PROCESS_MAP.MSAVI2]: {
    key: PROCESS_MAP.MSAVI2,
    name: PROCESS_MAP.MSAVI2.toUpperCase(),
    label: 'Modified Soil Adjusted Vegetation Index',
  },
  [PROCESS_MAP.MTVI2]: {
    key: PROCESS_MAP.MTVI2,
    name: PROCESS_MAP.MTVI2.toUpperCase(),
    label: 'Modified Triangular Vegetation Index',
  },
} as const;
